import styled from 'styled-components/native';
import { Pressable, View } from 'react-native';

export const AddContactButton = styled(Pressable)`
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  margin-top: 5px;
  width: 80%;
  align-self: center;
  background-color: #fff;
  text-align: center;
`;

export const ButtonContainer = styled(View)`

`;